import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import { Button } from './ui/button';
import { AlertTriangle, ArrowLeft, User } from 'lucide-react';
import { toast } from 'sonner';

const ImpersonationBanner = () => {
  const { isImpersonating, impersonation, endImpersonation } = useAuth();

  if (!isImpersonating || !impersonation) {
    return null;
  }

  const handleEndImpersonation = async () => {
    const result = await endImpersonation();
    if (result.success) {
      toast.success('Retour à votre compte SuperAdmin');
      window.location.href = '/superadmin';
    } else {
      toast.error('Erreur lors du retour au compte original');
    }
  };

  return (
    <div className="fixed top-0 left-0 right-0 z-[9999] bg-gradient-to-r from-orange-500 to-amber-500 text-white px-4 py-2 shadow-lg">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-2 bg-white/20 rounded-full px-3 py-1">
            <AlertTriangle className="h-4 w-4" />
            <span className="text-sm font-medium">Mode Impersonation</span>
          </div>
          <div className="flex items-center gap-2">
            <User className="h-4 w-4" />
            <span className="font-semibold">
              {impersonation.client?.name || impersonation.impersonatedUser?.name}
            </span>
            <span className="text-white/80 text-sm">
              ({impersonation.impersonatedUser?.email})
            </span>
          </div>
        </div>
        
        <Button
          onClick={handleEndImpersonation}
          variant="secondary"
          size="sm"
          className="bg-white text-orange-600 hover:bg-orange-50 font-semibold rounded-full px-4"
        >
          <ArrowLeft className="h-4 w-4 mr-2" />
          Revenir à mon compte
        </Button>
      </div>
    </div>
  );
};

export default ImpersonationBanner;
